<script lang="ts">
	// Stores
	import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { devices_config } from 'src/configs/devices';

	// Helpers
	import { real_id } from 'src/helpers/interface_helpers';
	import { status_configurator } from 'src/helpers/device_data_helpers';

	// Components
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import PeripheralAdvancedDeviceDrawerV2 from 'src/components/DevicesSettings/AddonSettingsG2/PeripheralDevice/PeripheralAdvancedDeviceDrawerV2.svelte';
	import { getDeviceChartsConfig } from 'src/components/Chart/chart_config';

	// Types
	import type { Device } from 'src/types/Device';
	import type { ChartConfigInterface } from 'src/types/Chart';

	export let device: Device;
	export let statuses: unknown[] | undefined;
	export let deviceChartsConfig: ChartConfigInterface[] | undefined;
	export let handleOnClickThumbChart: (e: CustomEvent | Event) => void = () => {};

	const deviceConfig = devices_config?.[device?.type];

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;

	$: _statusesRaw =
		status?.online && (typeof deviceConfig !== 'undefined' || device?.type === 'peripheral-device')
			? status_configurator(status, device, settings)
			: [];
	$: _statuses = statuses ?? (Array.isArray(_statusesRaw) ? _statusesRaw : []);
	$: _deviceChartsConfig = deviceChartsConfig ?? (device ? getDeviceChartsConfig(device) : []);
</script>

<DeviceViewStateWrapper {device}>
	<div class="flex-full-height justify-content-end mt-s" slot="staticBottom">
		<PeripheralAdvancedDeviceDrawerV2
			{device}
			statuses={_statuses}
			deviceChartsConfig={_deviceChartsConfig}
			{handleOnClickThumbChart}
		/>
	</div>
</DeviceViewStateWrapper>
